import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["inputValue", "onInputChange"],
  _excluded2 = ["inputValue", "onInputChange"];
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Button } from '../../Button';
import { InputField } from '../../InputField';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FilterRange(props) {
  var maxInputFieldProps = props.maxInputFieldProps,
    minInputFieldProps = props.minInputFieldProps,
    onSubmitClick = props.onSubmitClick,
    submitButtonProps = props.submitButtonProps;
  var maxInputFieldInputValue = maxInputFieldProps.inputValue,
    onMaxInputFieldSearch = maxInputFieldProps.onInputChange,
    otherMaxInputFieldProps = _objectWithoutProperties(maxInputFieldProps, _excluded);
  var minInputFieldInputValue = minInputFieldProps.inputValue,
    onMinInputFieldSearch = minInputFieldProps.onInputChange,
    otherMinInputFieldProps = _objectWithoutProperties(minInputFieldProps, _excluded2);
  var theme = useTheme();
  return /*#__PURE__*/_jsxs(Stack, {
    flexDirection: "row",
    sx: {
      alignItems: 'center',
      gap: '8px',
      padding: '16px 16px 0px 16px'
    },
    "data-element": "Stack",
    "data-component": "FilterRange",
    "data-source-file": "FilterRange.tsx",
    children: [/*#__PURE__*/_jsx(InputField, _extends({
      onChange: function onChange(e) {
        return onMinInputFieldSearch && onMinInputFieldSearch(e);
      },
      value: minInputFieldInputValue
    }, otherMinInputFieldProps, {
      "data-element": "InputField",
      "data-source-file": "FilterRange.tsx"
    })), /*#__PURE__*/_jsx(Typography, {
      color: theme.palette.gray[700],
      variant: "text-md-medium",
      "data-element": "Typography",
      "data-source-file": "FilterRange.tsx",
      children: "to"
    }), /*#__PURE__*/_jsx(InputField, _extends({
      onChange: function onChange(e) {
        return onMaxInputFieldSearch && onMaxInputFieldSearch(e);
      },
      value: maxInputFieldInputValue
    }, otherMaxInputFieldProps, {
      "data-element": "InputField",
      "data-source-file": "FilterRange.tsx"
    })), /*#__PURE__*/_jsx(Button, _extends({
      onClick: function onClick() {
        return onSubmitClick(minInputFieldInputValue, maxInputFieldInputValue);
      }
    }, submitButtonProps, {
      "data-element": "Button",
      "data-source-file": "FilterRange.tsx"
    }))]
  });
}